define("settings/components/downgrade-slide-complete", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tDG--slide" data-test-id="complete-slide">
    <div class="o--modalBody u--text--center">
      <h2 class="tDG--text--success">
        {{t "account.downgrade.complete.downgrade_complete"}}
      </h2>
      {{! 
        Note: This intentionally uses anchor tags to force a page reload.
        Necessary to unload disconnected social profiles after destroying a social set.
      }}
      <a class="u--m__r" href="/plans" {{button variant="outline"}}>
        {{t "account.downgrade.complete.view_paid_plans"}}
      </a>
      <a href="/account/overview" {{button variant="proceed"}}>
        {{t "account.downgrade.complete.view_account_summary"}}
      </a>
    </div>
  </div>
  */
  {
    "id": "XRRxEJ/x",
    "block": "[[[10,0],[14,0,\"tDG--slide\"],[14,\"data-test-id\",\"complete-slide\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--modalBody u--text--center\"],[12],[1,\"\\n    \"],[10,\"h2\"],[14,0,\"tDG--text--success\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.downgrade.complete.downgrade_complete\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"],[1,\"    \"],[11,3],[24,0,\"u--m__r\"],[24,6,\"/plans\"],[4,[38,1],null,[[\"variant\"],[\"outline\"]]],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.downgrade.complete.view_paid_plans\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[11,3],[24,6,\"/account/overview\"],[4,[38,1],null,[[\"variant\"],[\"proceed\"]]],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.downgrade.complete.view_account_summary\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"t\",\"button\"]]",
    "moduleName": "settings/components/downgrade-slide-complete.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});